import { useEffect, useState } from 'react';
import { productsAPI } from '../services/api';

const Chip = ({ on, onClick, testId, children }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`rounded-lg border px-3 py-1.5 text-xs font-semibold transition-colors ${
      on ? 'border-green-600 bg-green-600 text-white' : 'border-gray-300 bg-white text-gray-700'}`}>
    {children}
  </button>
);

export const MobilePreownedFilters = ({ category, selectedGrades, onGradeToggle, selectedStorages, onStorageToggle }) => {
  const [grades, setGrades] = useState([]);
  const [storages, setStorages] = useState([]);

  useEffect(() => {
    productsAPI.getGrades(category).then((r) => setGrades(r.data || [])).catch(() => setGrades([]));
    productsAPI.getStorages(category).then((r) => setStorages(r.data || [])).catch(() => setStorages([]));
  }, [category]);

  if (!grades.length && !storages.length) return null;
  return (
    <>
      {grades.length > 0 && (
        <div className="mb-6" data-testid="mobile-grade-filter-group">
          <h4 className="font-semibold mb-3">Stare estetică</h4>
          <div className="flex flex-wrap gap-2">
            {grades.map((g) => (
              <Chip key={g.grade} on={selectedGrades.includes(g.grade)} onClick={() => onGradeToggle(g.grade)}
                testId={`mobile-grade-${g.grade}`}>Grad {g.grade} ({g.count})</Chip>
            ))}
          </div>
        </div>
      )}
      {storages.length > 0 && (
        <div className="mb-6" data-testid="mobile-storage-filter-group">
          <h4 className="font-semibold mb-3">Capacitate</h4>
          <div className="flex flex-wrap gap-2">
            {storages.map((s) => (
              <Chip key={s.storage} on={selectedStorages.includes(s.storage)} onClick={() => onStorageToggle(s.storage)}
                testId={`mobile-storage-${s.storage}`}>{s.storage} ({s.count})</Chip>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
